<div fxLayout="column">
  <h3>தீர்மானத்தை தேர்ந்தெடுக்கவும்</h3>
  <div class="content" fxLayout="column" fxFlex="1 0 auto">
    <mat-form-field appearance="outline" fxFlex="50" class="pr-4">
      <mat-label>{{ "Events" | translate }}</mat-label>
      <mat-select (change)="onDropdownChange()" [(ngModel)]="selectedEventId">
        <mat-option *ngFor="let event of events" [value]="event.event_id">
          #{{ event.event_id }} {{ event.event_date }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <div fxLayout="row" fxLayoutAlign="center">
      <button (click)="onCancelClick()" mat-raised-button class="bg-danger">
        {{ "Cancel" | translate }}
      </button>
      <button
        [disabled]="disableSaveBtn()"
        [ngClass]="disableSaveBtn() == false ? 'bg-success' : 'bg-secondary'"
        (click)="onOkClick()"
        mat-raised-button
      >
        {{ "Save" | translate }}
      </button>
    </div>
  </div>
</div>
